export * from './app-sidebar-footer.component';



// WEBPACK FOOTER //
// /app/src/app/components/app-sidebar-footer/index.ts